import { FormSectionHeading as SharedFormSectionHeading, type FormSectionHeadingProps as SharedFormSectionHeadingProps } from "../../../../../shared/frontend/components/FormSectionHeading";
import { useI18n } from "../app/i18n/useI18n";

export type FormSectionHeadingProps = Omit<SharedFormSectionHeadingProps, "collapsed" | "onCollapsedChange" | "expandLabel" | "collapseLabel">;

/** Product labels; renderer and per-account collapse state (FormSectionCollapseRoot) belong to Shared. */
export function FormSectionHeading(props: FormSectionHeadingProps) {
  const { text } = useI18n();
  return <SharedFormSectionHeading {...props} expandLabel={text("Expand section")} collapseLabel={text("Collapse section")} />;
}
